import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import {SxProps} from '@mui/material/styles';
import HeaderLogo from '../../public/images/newAmplifyLogoFullColor.svg';
import Plus from '../icons/Plus';
import {usePartnerBrandings} from './usePartnerBrandings';

interface CoBrandedLogoProps {
    source: string;
    sx?: SxProps;
}

const CoBrandedLogo: React.FC<CoBrandedLogoProps> = ({source, sx = {}}) => {
    const {logoMap} = usePartnerBrandings();
    const logoSrc = logoMap[source?.toLowerCase()];

    if (!logoSrc) return null;

    return (
        <Stack direction="row" alignItems="center" sx={{gap: {xs: '8px', md: '20px'}, maxWidth: {md: 400}, ...sx}}>
            <Box
                sx={{
                    flex: {xs: 1, md: 'none'},
                    minWidth: 0,
                    maxWidth: {md: 160},
                    '& svg': {width: '100%', height: 'auto'},
                }}
            >
                <HeaderLogo />
            </Box>
            <Box sx={{alignSelf: 'stretch', display: 'flex', alignItems: 'center', flexShrink: 0}}>
                <Plus sx={{width: {xs: 12, md: 17}, height: {xs: 12, md: 17}}} />
            </Box>
            <Box
                component="img"
                src={logoSrc}
                alt={source}
                sx={{flex: {xs: 1, md: 'none'}, minWidth: 0, maxWidth: {md: 128}, objectFit: 'contain'}}
            />
        </Stack>
    );
};

export default CoBrandedLogo;
